'use client'
import {
  FocusLock
} from "./chunk-UU5OHSNF.mjs";
export {
  FocusLock
};
//# sourceMappingURL=index.mjs.map